import { render, staticRenderFns } from "./BadgeCampaignForm.vue?vue&type=template&id=3852a639&"
import script from "./BadgeCampaignForm.vue?vue&type=script&lang=js&"
export * from "./BadgeCampaignForm.vue?vue&type=script&lang=js&"
import style0 from "./BadgeCampaignForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports